<template>
  <b-dropdown ref="vatDropdown" class="gk-vat-input" toggle-class="gk-vat-input--toggle" no-caret :disabled="disabled" @shown="focusTaxInput">
    <template #button-content>
      <div v-show="!isExempt">
        <b-input-group class="icon-contained-input-group">
          <b-form-input name="tax_rate" ref="taxRateInput" v-model="localVatValue" size="4" type="number" id="vat-numeric-input" step="any" required :disabled="disabled" />
          <b-input-group-append>
            <b-input-group-text>%</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div v-show="isExempt">{{ $gettext("VAT exempt") }} <span style="font-size: 14px;"><font-awesome-icon icon="fa-solid fa-caret-down" /></span></div>
    </template>
    <b-dropdown-item 
      v-for="(tax_rate, tax_index) in companyTaxRates"
      :value="tax_rate.taxrate"
      :key="'tax_rate-' + tax_index"
      @click="selectTaxRate(tax_index)"
    >
      {{ tax_rate.name }}
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item @click="selectTaxRate('exempt')">{{ $gettext("VAT exempt") }}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "VatInput",
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    defaultExempt: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
      companyTaxRates: "invoices/getCompanyTaxRates"
    }),
    localVatValue: {
      get () { return this.value },
      set (localVatValue) { this.$emit('input', localVatValue)  }
    },
    isExempt () {
      return this.localVatValue === 'exempt'
    }
  },
  created () {
    if (!this.companyTaxRates) this.loadCompanyTaxRates()
  },
  methods: {
    ...mapActions ({
      loadCompanyTaxRates: "invoices/loadCompanyTaxRates"
    }),
    updateValue (selectedTaxRate) {
      this.$emit('input', selectedTaxRate)
    },
    focusTaxInput () {
      this.$refs.taxRateInput.focus()
    },
    selectTaxRate (tax_index) {
      if (tax_index === 'exempt') {
        this.localVatValue = tax_index
      } else {
        this.localVatValue = this.companyTaxRates[tax_index].taxrate
      }
    }
  },
}
</script>

<style lang="scss">
  .gk-vat-input {
    &--toggle {
      padding: 0 !important;
      border: 0 !important;
      background: none !important;
      color: $colorTextBase !important;
      user-select: text !important;
      input { user-select: text !important; }
      &.btn.disabled, &.btn:disabled {
        color: $colorTextBase !important;
        opacity: 1 !important;
      }

      &.disabled {
        .input-group-append {
          .input-group-text {
            background: #e9ecef;
          }
        }
      }
    }
    #vat-numeric-input {
      min-width: 60px;
      border-right: 0;
      text-align: right;
      padding-right: 5px;
    }
    .input-group-text {
      padding: 0.25rem 0.5rem;
      padding-left: 0;
      color: $colorTextLight;
    }
  }
</style>